import { createBlock, openBlock, unref, withCtx, renderSlot } from "vue";
import _sfc_main$1 from "./control_string.vue.js";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
const __default__ = {
  name: "DtcControlBase"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: void 0,
      default: () => String()
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      var _a;
      return openBlock(), createBlock(_sfc_main$1, {
        value: (_a = __props.value) == null ? void 0 : _a.toString(),
        disabled: __props.disabled,
        "onUpdate:value": _cache[0] || (_cache[0] = (e) => emit(unref(VALUE_UPDATE_EVENT), e))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["value", "disabled"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=control_base.vue.js.map
